import {
  GetOrdersBidsV6InfiniteQueryResult,
  GetOrdersBidsV6Params,
  getGetOrdersBidsV6InfiniteQueryOptions,
  useGetOrdersBidsV6Infinite,
} from '@/lib/reservoir/reservoir.generated';
import { ReservoirChain } from '@/utils/chains';
import { isDefined } from '@onbeam/utils';
import { useMarketplaceChain } from './use-marketplace-chain';

export const OFFERS_ITEMS_PER_PAGE = 9;

const params: Partial<GetOrdersBidsV6Params> = {
  limit: OFFERS_ITEMS_PER_PAGE,
  includeCriteriaMetadata: true,
};

const getUserOffers = (
  chain: ReservoirChain,
  address: string,
  override?: Partial<GetOrdersBidsV6Params>,
) => {
  return getGetOrdersBidsV6InfiniteQueryOptions(
    {
      ...params,
      ...override,
      maker: address,
    },
    {
      query: {
        enabled: !!address,
        queryKey: ['/orders/bids/v6', chain.id, address, params, override],
        getNextPageParam: (lastPage: GetOrdersBidsV6InfiniteQueryResult) => lastPage.continuation,
      },
      request: {
        baseURL: `${process.env.NEXT_PUBLIC_HOST_URL}${chain.proxyApi}`,
      },
    },
  );
};

const useUserOffers = (address: string, override?: Partial<GetOrdersBidsV6Params>) => {
  const chain = useMarketplaceChain();

  const { data, ...request } = useGetOrdersBidsV6Infinite(
    {
      ...params,
      ...override,
      maker: address,
    },
    {
      query: {
        enabled: !!address,
        queryKey: ['/orders/bids/v6', chain.id, address, params, override],
        getNextPageParam: (lastPage: GetOrdersBidsV6InfiniteQueryResult) =>
          lastPage.continuation || undefined,
      },
      request: {
        baseURL: `${process.env.NEXT_PUBLIC_HOST_URL}${chain.proxyApi}`,
      },
    },
  );

  return {
    data: (data?.pages || []).flatMap(page => page.orders).filter(isDefined),
    ...request,
  };
};

const isSingleOrder = (offer: ReturnType<typeof useUserOffers>['data'][number]) =>
  offer.criteria?.kind === 'token';

const isAttributeOffer = (activity: ReturnType<typeof useUserOffers>['data'][number]) =>
  // @ts-expect-error - `kind` type is wrong
  activity.criteria?.kind === 'attribute';

export { getUserOffers, isAttributeOffer, isSingleOrder, useUserOffers };
